<button id="closebutton" aria-label="close filter options" type="button"
(click)="closeDialog()">CLOSE <span class="material-symbols-outlined cancel-icon">
    cancel
</span> </button>
<h2 id="sample-plan-desc">Sample CPD Plan</h2>
<mat-card appearance="outlined" class="inner">
    <h3>Competency 1: Manage files effectively and securely</h3>
    <div class="domain">Domain: Practice Management</div>
    <div class="proficiency-rating">Self-Assessment Proficiency Rating: <span>Do</span></div>
    <div class="activity-item">
        <small>Learning Activity</small>
        <span class="activity-name">Be a mentor or mentee</span>
    </div>
    <div class="activity-item">
        <small>Learning Activity</small>
        <span class="activity-name">Attend organization or association meetings or events</span>
    </div>
    <div class="activity-item">
        <small>Notes About Learning Activities</small>
        <span class="activity-name">A mentor could provide a variety of information and suggestions relating to both file management and continuous improvement in the provision of services, that I can consider and potentially incorporate into my practice.<br><br>
         I plan to join a CBA section that focuses on Practice Management. The section meetings provide up-to-date information provincially on best practices that I can consider and potentially incorporate into my practice, and allows for networking and exchange of ideas with other members.</span>
    </div>
</mat-card>
<mat-card appearance="outlined" class="inner">
    <h3>Competency 2: Familiarize myself with the new XYZ Act</h3>
    <div class="proficiency-rating">Self-Assessment Proficiency Rating: <span>Discover</span></div>
    <div class="activity-item">
        <small>Learning Activity.</small>
        <span class="activity-name">Take a course or seminar - in person</span>
    </div>
    <div class="activity-item">
        <small>Notes About Learning Activities</small>
        <span class="activity-name">I plan to attend the LESA seminar on this topic. This seminar will allow me to learn about the new Act, network and exchange ideas with other attendees.<br>
        </span>
    </div>
</mat-card>
<mat-card appearance="outlined" class="inner">
    <h3>Competency 3: Commit to continuous improvement in the provision of services</h3>
    <div class="domain">Domain: Continuous Improvement</div>
    <div class="proficiency-rating">Self-Assessment Proficiency Rating: <span>Attempt</span></div>
    <div class="activity-item">
        <small>Learning Activity</small>
        <span class="activity-name">Read one article per week on this subject</span>
    </div>
    <div class="activity-item">
        <small>Learning Activity</small>
        <span class="activity-name">Collect feedback from my clients about my services</span>
    </div>
    <div class="activity-item">
        <small>Notes About Learning Activities</small>
        <span class="activity-name">The articles will allow me to review information, experiences and suggestions from a variety of audiences in different jurisdictions.<br><br>
        I could create a survey for clients to complete upon closure of each matter to understand what worked well for them and areas where they felt they needed more information, etc.</span>
    </div>
</mat-card>
